export default function SaveStatusBadge({ status }) {
    if (!status || status === "idle") return null;

    const styles = {
        dirty: {
            label: "Brouillon",
            bg: "#fffbeb",
            border: "#fde68a",
            color: "#92400e",
        },
        saving: {
            label: "En sauvegarde",
            bg: "#eff6ff",
            border: "#bfdbfe",
            color: "#1d4ed8",
        },
        saved: {
            label: "Sauvegardé",
            bg: "#f0fdf4",
            border: "#bbf7d0",
            color: "#166534",
        },
        error: {
            label: "Erreur sauvegarde",
            bg: "#fef2f2",
            border: "#fecaca",
            color: "#b91c1c",
        },
    };

    const s = styles[status];
    if (!s) return null;

    return (
        <span
            role="status"
            aria-live="polite"
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "92px",
                minHeight: "20px",
                padding: "2px 8px",
                borderRadius: "999px",
                border: `1px solid ${s.border}`,
                background: s.bg,
                color: s.color,
                fontSize: "10.5px",
                fontWeight: 700,
                lineHeight: 1.2,
                whiteSpace: "nowrap",
            }}
        >
            {s.label}
        </span>
    );
}

export function productionSaveStatus(rows) {
    if (!rows || rows.length === 0) return "idle";
    if (rows.some(row => row._saveError)) return "error";
    if (rows.some(row => row._saving)) return "saving";
    if (rows.some(row => row._dirty)) return "dirty";
    if (rows.some(row => row._saved)) return "saved";
    return "idle";
}
